import { Heading, HeadingProps, Stack, Text, TextProps } from '@chakra-ui/react';

import { Button } from '#features/ui';

type PlaceholderProps = {
  icon: React.ReactNode;
  children: React.ReactNode;
};

export const Placeholder = ({ children, icon }: PlaceholderProps) => {
  return (
    <Stack
      pt={{ base: '30px', md: '160px' }}
      pb="30px"
      gap={5}
      justifyContent="center"
      alignSelf="center"
      alignItems="center"
    >
      {icon}
      {children}
    </Stack>
  );
};

Placeholder.Button = Button;

Placeholder.Title = ({ children, ...props }: HeadingProps) => (
  <Heading textStyle="heading" fontWeight="medium" textAlign="center" {...props}>
    {children}
  </Heading>
);

Placeholder.Description = ({ children, ...props }: TextProps) => (
  <Text color="brand.400" textAlign="center" {...props}>
    {children}
  </Text>
);
